import { render } from "./lesson.vue?vue&type=template&id=96ca561c"
import script from "./lesson.vue?vue&type=script&lang=js"
export * from "./lesson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__